<template>
    <div>
        <modal
            :is-open="isOpen"
            :is-loading="loading"
            :disabled="loading"
            :title="
                productIds.length === 1
                    ? 'Удалить изделие?'
                    : 'Удалить изделия?'
            "
            btn-save-title="Подтвердить"
            @onCloseModal="closeModal"
            @onSaveModal="saveModal"
        >
            <div v-if="productIds.length > 1">
                Выбрано изделий: {{ productIds.length }}
            </div>

            <div class="app-modal__message mt-20 d-flex">
                <div class="app-modal__icon"></div>
                Внимание! Удаленные изделия невозможно восстановить.
            </div>
        </modal>
    </div>
</template>

<script>
import Modal from '@/components/Elements/Modal'

import { mapActions } from 'vuex'

export default {
    name: 'DeleteMass',
    components: { Modal },
    props: {
        productIds: {
            type: Array,
            required: true
        },
        isOpen: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading: false
        }
    },
    methods: {
        ...mapActions('supplierProducts', ['deleteProductsMass']),
        closeModal() {
            this.$emit('closeModal')
        },
        async saveModal() {
            if (this.loading) return

            this.loading = true

            let data = {
                Items: this.productIds
            }

            try {
                let payload = {
                    type: 'access',
                    data
                }
                await this.deleteProductsMass(payload)

                this.$notify({
                    title: 'Изделия удалены',
                    type: 'success'
                })

                this.$emit('onDeleteMassSaved')
            } catch (e) {
                console.log(e)
                this.$notify({
                    title: 'Ошибка',
                    type: 'error'
                })
            }

            this.loading = false
            this.closeModal()
        }
    }
}
</script>
